import ChangePassword from "../views/ChangePassword";

export default [
	{
		path: "/change_password",
		meta: { requiresLoggedIn: true },
		components: {
			content: ChangePassword
		}
	}
];
